export const revokeResult = {
  undefined: 'Undefined',
  revoked: 'Revoked',
  removed: 'Removed',
  removedWithTeam: 'RemovedWithTeam',
};

export const revokeConfirmationFormId = 'revokeConfirmationForm';
